import { Router } from '@solidjs/router'
import { render } from 'solid-js/web'
import { ClerkProvider } from './shared/providers/clerk'
import { AppRoot, AppRoutesComponent } from './App'
import './index.css'
import './App.scss'
import { CorisProvider } from './shared/providers/coris/coris.provider'
import { initPosthogBridge } from './shared/feature-flags'

const root = document.getElementById('root')

if (import.meta.env.DEV && !(root instanceof HTMLElement)) {
  throw new Error(
    'Root element not found. Did you forget to add it to your index.html? Or maybe the id attribute got misspelled?'
  )
}

const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!clerkPublishableKey) {
  throw new Error(
    'Missing VITE_CLERK_PUBLISHABLE_KEY environment variable. ' +
      'Add it to environments/.env.local file:\n' +
      'VITE_CLERK_PUBLISHABLE_KEY=pk_test_your_key_here'
  )
}

const posthogKey = import.meta.env.VITE_POSTHOG_KEY
const posthogHost = import.meta.env.VITE_POSTHOG_HOST

if (posthogKey && posthogHost) {
  initPosthogBridge({ key: posthogKey, host: posthogHost })
} else if (import.meta.env.DEV) {
  // Non-fatal in dev — feature flags fall back to declared defaults.
  // eslint-disable-next-line no-console
  console.warn('[feature-flags] VITE_POSTHOG_KEY or VITE_POSTHOG_HOST not set — flags will use declared defaults.')
}

render(
  () => (
    <ClerkProvider publishableKey={clerkPublishableKey}>
      <CorisProvider>
        <Router root={AppRoot}>
          <AppRoutesComponent />
        </Router>
      </CorisProvider>
    </ClerkProvider>
  ),
  root!
)
